import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store';
import Axios from 'axios';
import setting from './../setting';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    redirect: 'locale',
  },
  {
    path: '/sos_request',
    name: 'sos_request',
    component: () => import('../views/SosRequest/Index.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/sos_request/create',
    name: 'sos_request_create',
    component: () => import('../views/SosRequest/Create.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/sos_request/:id',
    name: 'sos_request_read',
    component: () => import('../views/SosRequest/Read.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/sos_request/:id/update',
    name: 'sos_request_update',
    component: () => import('../views/SosRequest/Update.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/feedback',
    name: 'feedback',
    component: () => import('../views/Feedback.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/legal_inquiry',
    name: 'legal_inquiry',
    component: () => import('../views/LegalInquiry/Index.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/legal_inquiry/create',
    name: 'legal_inquiry_create',
    component: () => import('../views/LegalInquiry/Create.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/legal_inquiry/:id',
    name: 'legal_inquiry_read',
    component: () => import('../views/LegalInquiry/Read.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/legal_inquiry/:id/update',
    name: 'legal_inquiry_update',
    component: () => import('../views/LegalInquiry/Update.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/locale',
    name: 'locale',
    component: () => import('../views/Locale.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/tag',
    name: 'tag',
    component: () => import('../views/Tag.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/area',
    name: 'area',
    component: () => import('../views/Area/Index.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/area/create',
    name: 'area_create',
    component: () => import('../views/Area/Create.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/area/:id',
    name: 'area_read',
    component: () => import('../views/Area/Read.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/area/:id/update',
    name: 'area_update',
    component: () => import('../views/Area/Update.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/area/:id/area_sections',
    name: 'area_sections_multi_list',
    component: () => import('../views/Area/AreaSections/MultiList.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/area/:id/area_sections/update',
    name: 'area_sections_update',
    component: () => import('../views/Area/AreaSections/Update.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/act_type',
    name: 'act_type',
    component: () => import('../views/ActType.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/act_status',
    name: 'act_status',
    component: () => import('../views/ActStatus/ActStatus.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/act',
    name: 'act',
    component: () => import('../views/Act.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/act/create',
    name: 'act_create',
    component: () => import('../views/ActCreate.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/act/:id',
    name: 'act_read',
    component: () => import('../views/ActRead.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/act/:id/update',
    name: 'act_update',
    component: () => import('../views/ActUpdate.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/act/:id/version/create',
    name: 'act_version_create',
    component: () => import('../views/ActVersionCreate.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/act/:id/version/create_without_idtf',
    name: 'act_version_create_without_idtf',
    component: () => import('../views/Act/Version/ActVersionCreateWithoutIdtf.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/act_version/:version_id/article/create/batch',
    name: 'article_create_batch',
    component: () => import('../views/ArticleCreateBatch.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/act/:id/act_version/:version_id/article/batch-create-multi-lang',
    name: 'article_create_batch_multi_lang',
    component: () => import('../views/Act/Article/BatchCreateMultiLang.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/act/:id/version',
    name: 'act_version',
    component: () => import('../views/ActVersion.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/act/:id/version/:version_id/update',
    name: 'act_version_update',
    component: () => import('../views/Act/Version/Update.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/act/:id/relatedtemplate/:version_id',
    name: 'act_related_template',
    component: () =>
      import('../views/ActRelatedTemplate/ActRelatedTemplate.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/act/:id/subscribed_factories',
    name: 'act_subscribed_factories',
    component: () => import('../views/Act/MultiList.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/act/:id/comment-idtf/create',
    name: 'act_comment_idtf_create',
    component: () => import('../views/ActIdentification/CommentIdtf/Create.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/article/:id/version/create',
    name: 'article_version_create',
    component: () => import('../views/Article/Version/Create.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/article/:id/version',
    name: 'article_version',
    component: () => import('../views/Article/Version/Index.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/article/:id/version/:version_id/update',
    name: 'article_version_update',
    component: () => import('../views/Article/Version/Update.vue'),
    meta: {
      requiresAuth: true,
    },
  },

  {
    path: '/effect',
    name: 'effect',
    component: () => import('../views/Effect.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/industry_category',
    name: 'industry_category',
    component: () => import('../views/IndustryCategory/Index.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/industry_category/create',
    name: 'industry_category_create',
    component: () => import('../views/IndustryCategory/Create.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/industry_category/:id',
    name: 'industry_category_read',
    component: () => import('../views/IndustryCategory/Read.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/industry_category/:id/update',
    name: 'industry_category_update',
    component: () => import('../views/IndustryCategory/Update.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/industry_category/:id/industry_categories',
    name: 'industry_categories_multi_list',
    component: () => import('../views/IndustryCategory/IndustryCategories/MultiList.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/industry_category/:id/industry_categories/update',
    name: 'industry_categories_update',
    component: () => import('../views/IndustryCategory/IndustryCategories/Update.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/user',
    name: 'user',
    component: () => import('../views/User.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/admin',
    name: 'admin',
    component: () => import('../views/Admin/Index.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/admin/create',
    name: 'admin_create',
    component: () => import('../views/Admin/Create.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/admin/:id',
    name: 'admin_read',
    component: () => import('../views/Admin/Read.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/admin/:id/update',
    name: 'admin_update',
    component: () => import('../views/Admin/Update.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/system_class',
    name: 'system_class',
    component: () => import('../views/SystemClass/Index.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/system_class/create',
    name: 'system_class_create',
    component: () => import('../views/SystemClass/Create.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/system_class/:id',
    name: 'system_class_read',
    component: () => import('../views/SystemClass/Read.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/system_class/:id/update',
    name: 'system_class_update',
    component: () => import('../views/SystemClass/Update.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/license_type',
    name: 'license_type',
    component: () => import('../views/LicenseType.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/license_template',
    name: 'license_template',
    component: () => import('../views/LicenseTemplate/Index.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/license_template/create',
    name: 'license_template_create',
    component: () => import('../views/LicenseTemplate/Create.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/license_template/:id',
    name: 'license_template_read',
    component: () => import('../views/LicenseTemplate/Read.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/license_template/:id/update',
    name: 'license_template_update',
    component: () => import('../views/LicenseTemplate/Update.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/license_template/:id/version/create',
    name: 'license_template_version_create',
    component: () => import('../views/LicenseTemplate/Version/Create.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/license_template/:id/version/:version_id/update',
    name: 'license_template_version_update',
    component: () => import('../views/LicenseTemplate/Version/Update.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/license_template/:id/version',
    name: 'license_template_version',
    component: () => import('../views/LicenseTemplate/Version/Index.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/checklist_template',
    name: 'checklist_template',
    component: () => import('../views/ChecklistTemplate/Index.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/checklist_template/create',
    name: 'checklist_template_create',
    component: () => import('../views/ChecklistTemplate/Create.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/checklist_template/:id',
    name: 'checklist_template_read',
    component: () => import('../views/ChecklistTemplate/Read.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/checklist_template/:id/update',
    name: 'checklist_template_update',
    component: () => import('../views/ChecklistTemplate/Update.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/checklist_template/:id/version/create',
    name: 'checklist_template_version_create',
    component: () => import('../views/ChecklistTemplate/Version/Create.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/checklist_template/:id/version/:version_id/update',
    name: 'checklist_template_version_update',
    component: () => import('../views/ChecklistTemplate/Version/Update.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/checklist_template/:id/version',
    name: 'checklist_template_version',
    component: () => import('../views/ChecklistTemplate/Version/Index.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/checklist_template/:id/duplicate',
    name: 'checklist_template_duplicate',
    component: () => import('../views/ChecklistTemplate/Duplicate.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/cklist_ques_tmp_ver/:id/version',
    name: 'checklist_template_question_version',
    component: () => import('../views/ChecklistTemplate/Version/Index.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/checklist_conclusion_daily_template',
    name: 'checklist_conclusion_daily_template',
    component: () =>
      import('../views/ChecklistConclusionDailyTemplate/Index.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/checklist_conclusion_daily_template/create',
    name: 'checklist_conclusion_daily_template_create',
    component: () =>
      import('../views/ChecklistConclusionDailyTemplate/Create.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/checklist_conclusion_daily_template/:id',
    name: 'checklist_conclusion_daily_template_read',
    component: () =>
      import('../views/ChecklistConclusionDailyTemplate/Read.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/checklist_conclusion_daily_template/:id/update',
    name: 'checklist_conclusion_daily_template_update',
    component: () =>
      import('../views/ChecklistConclusionDailyTemplate/Update.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/checklist_conclusion_daily_template/:id/version/create',
    name: 'checklist_conclusion_daily_template_version_create',
    component: () =>
      import('../views/ChecklistConclusionDailyTemplate/Version/Create.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/checklist_conclusion_daily_template/:id/version',
    name: 'checklist_conclusion_daily_template_version',
    component: () =>
      import('../views/ChecklistConclusionDailyTemplate/Version/Index.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/answer_setting',
    name: 'answer_setting',
    component: () => import('../views/ChecklistTemplate/Option/Index.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/answer_setting/create',
    name: 'answer_setting_create',
    component: () => import('../views/ChecklistTemplate/Option/Create.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/answer_setting/:id',
    name: 'answer_setting_read',
    component: () => import('../views/ChecklistTemplate/Option/Read.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/answer_setting/:id/update',
    name: 'answer_setting_update',
    component: () => import('../views/ChecklistTemplate/Option/Update.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/audit_template',
    name: 'audit_template',
    component: () => import('../views/AuditTemplate/Index.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/audit_template/create',
    name: 'audit_template_create',
    component: () => import('../views/AuditTemplate/Create.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/audit_template/:id',
    name: 'audit_template_read',
    component: () => import('../views/AuditTemplate/Read.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/audit_template/:id/update',
    name: 'audit_template_update',
    component: () => import('../views/AuditTemplate/Update.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/audit_template/:id/version/:version_id/update',
    name: 'audit_template_version_update',
    component: () => import('../views/AuditTemplate/Version/Update.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/audit_template/:id/version/create',
    name: 'audit_template_version_create',
    component: () => import('../views/AuditTemplate/Version/Create.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/audit_template/:id/version',
    name: 'audit_template_version',
    component: () => import('../views/AuditTemplate/Version/Index.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/audit_template/:id/add_chapter/:version_id',
    name: 'audit_template_add_chapter',
    component: () => import('../views/AuditTemplate/AddChapter.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/audit_template/:id/create_version/:version_id',
    name: 'audit_template_create_version',
    component: () => import('../views/AuditTemplate/CreateVersion.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/audit_template/:id/duplicate',
    name: 'audit_template_duplicate',
    component: () => import('../views/AuditTemplate/Duplicate.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/event_type',
    name: 'event_type',
    component: () => import('../views/EventType/EventType.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/contractor_type',
    name: 'contractor_type',
    component: () => import('../views/ContractorType/Index.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/signin',
    name: 'signin',
    component: () => import('@/__vue2cmsstonevuetify/layouts/SigninView.vue'),
    meta: {
      template: 'auth',
    },
  },
  {
    path: '/signout',
    name: 'signout',
    component: () => import('@/__vue2cmsstonevuetify/layouts/SignoutView.vue'),
    meta: {
      template: 'auth',
    },
  },
  {
    path: '/404',
    name: '404',
    component: () => import('@/__vue2cmsstonevuetify/layouts/NotFoundView.vue'),
  },
  {
    path: '*',
    component: () => import('@/__vue2cmsstonevuetify/layouts/NotFoundView.vue'),
  },
  {
    path: '/external_training_template',
    name: 'external_training_template',
    component: () => import('../views/ExternalTrainingTemplate/Index.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/external_training_template/create',
    name: 'external_training_template_create',
    component: () => import('../views/ExternalTrainingTemplate/Create.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/external_training_template/:id',
    name: 'external_training_template_read',
    component: () => import('../views/ExternalTrainingTemplate/Read.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/external_training_template/:id/update',
    name: 'external_training_template_update',
    component: () => import('../views/ExternalTrainingTemplate/Update.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/internal_training_template',
    name: 'internal_training_template',
    component: () => import('../views/InternalTrainingTemplate/Index.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/internal_training_template/create',
    name: 'internal_training_template_create',
    component: () => import('../views/InternalTrainingTemplate/Create.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/internal_training_template/:id',
    name: 'internal_training_template_read',
    component: () => import('../views/InternalTrainingTemplate/Read.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/internal_training_template/:id/update',
    name: 'internal_training_template_update',
    component: () => import('../views/InternalTrainingTemplate/Update.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/internal_training_template/:id/version/create',
    name: 'internal_training_template_version_create',
    component: () =>
      import('../views/InternalTrainingTemplate/Version/Create.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/internal_training_template/:id/version/:version_id/update',
    name: 'internal_training_template_version_update',
    component: () =>
      import('../views/InternalTrainingTemplate/Version/Update.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/internal_training_template/:id/version',
    name: 'internal_training_template_version',
    component: () =>
      import('../views/InternalTrainingTemplate/Version/Index.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/contractor_license_template',
    name: 'contractor_license_template',
    component: () => import('../views/ContractorLicenseTemplate/Index.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/contractor_license_template/create',
    name: 'contractor_license_template_create',
    component: () => import('../views/ContractorLicenseTemplate/Create.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/contractor_license_template/:id',
    name: 'contractor_license_template_read',
    component: () => import('../views/ContractorLicenseTemplate/Read.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/contractor_license_template/:id/update',
    name: 'contractor_license_template_update',
    component: () => import('../views/ContractorLicenseTemplate/Update.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/contractor_license_template/:id/version/create',
    name: 'contractor_license_template_version_create',
    component: () =>
      import('../views/ContractorLicenseTemplate/Version/Create.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/contractor_license_template/:id/version/:version_id/update',
    name: 'contractor_license_template_version_update',
    component: () =>
      import('../views/ContractorLicenseTemplate/Version/Update.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/contractor_license_template/:id/version',
    name: 'contractor_license_template_version',
    component: () =>
      import('../views/ContractorLicenseTemplate/Version/Index.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/risk_template',
    name: 'risk_template',
    component: () => import('../views/RiskTemplate/Index.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/risk_template/create',
    name: 'risk_template_create',
    component: () => import('../views/RiskTemplate/Create.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/risk_template/:id',
    name: 'risk_template_read',
    component: () => import('../views/RiskTemplate/Read.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/risk_template/:id/update',
    name: 'risk_template_update',
    component: () => import('../views/RiskTemplate/Update.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/risk_template/:id/version/update',
    name: 'risk_template_version_update',
    component: () => import('../views/RiskTemplate/Version/Update.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/risk_template/:id/version',
    name: 'risk_template_version_index',
    component: () => import('../views/RiskTemplate/Version/Index.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/change_item_template',
    name: 'change_item_template',
    component: () => import('../views/ChangeItemTemplate/Index.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/change_item_template/create',
    name: 'change_item_template_create',
    component: () => import('../views/ChangeItemTemplate/Create.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/change_item_template/:id',
    name: 'change_item_template_read',
    component: () => import('../views/ChangeItemTemplate/Read.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/change_item_template/:id/update',
    name: 'change_item_template_update',
    component: () => import('../views/ChangeItemTemplate/Update.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/change_item_template/:id/version/update',
    name: 'change_item_version_template',
    component: () => import('../views/ChangeItemTemplate/Version/Update.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/change_item_template/:id/version',
    name: 'change_item_template_version',
    component: () => import('../views/ChangeItemTemplate/Version/Index.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/exit_check_item_template',
    name: 'exit_check_item_template',
    component: () => import('../views/ExitCheckItemTemplate/Index.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/exit_check_item_template/create',
    name: 'exit_check_item_template_create',
    component: () => import('../views/ExitCheckItemTemplate/Create.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/exit_check_item_template/:id',
    name: 'exit_check_item_template_read',
    component: () => import('../views/ExitCheckItemTemplate/Read.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/exit_check_item_template/:id/update',
    name: 'exit_check_item_template_update',
    component: () => import('../views/ExitCheckItemTemplate/Update.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/factory',
    name: 'factory',
    component: () => import('../views/Factory/Index.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/factory/create',
    name: 'factory_create',
    component: () => import('../views/Factory/Create.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/factory/:id',
    name: 'factory_read',
    component: () => import('../views/Factory/Read.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/factory/:id/update',
    name: 'factory_update',
    component: () => import('../views/Factory/Update.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/factory/:id/subscribe_act',
    name: 'factory_subscribe_act',
    component: () => import('../views/Factory/SubscribeAct.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/factory/:id/sync_api',
    name: 'factory_sync_api',
    component: () => import('../views/Factory/SyncApi/Index.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/factory/:id/sync_api/:syncApiId',
    name: 'factory_sync_api_read',
    component: () => import('../views/Factory/SyncApi/Read.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/factory/:id/copy',
    name: 'factory_copy',
    component: () => import('../views/Factory/Copy.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/organization',
    name: 'organization',
    component: () => import('../views/Organization/Index.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/organization/create',
    name: 'organization_create',
    component: () => import('../views/Organization/Create.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/organization/:id',
    name: 'organization_read',
    component: () => import('../views/Organization/Read.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/organization/:id/update',
    name: 'organization_update',
    component: () => import('../views/Organization/Update.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/user_factory_template_role',
    name: 'role',
    component: () => import('../views/Role/Index.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/user_factory_template_role/create',
    name: 'role_create',
    component: () => import('../views/Role/Create.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/user_factory_template_role/:id',
    name: 'role_read',
    component: () => import('../views/Role/Read.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/user_factory_template_role/:id/update',
    name: 'role_update',
    component: () => import('../views/Role/Update.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/user_organization_template_role',
    name: 'organization_role',
    component: () => import('../views/OrganizationRole/Index.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/user_organization_template_role/create',
    name: 'organization_role_create',
    component: () => import('../views/OrganizationRole/Create.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/user_organization_template_role/:id',
    name: 'organization_role_read',
    component: () => import('../views/OrganizationRole/Read.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/user_organization_template_role/:id/update',
    name: 'organization_role_update',
    component: () => import('../views/OrganizationRole/Update.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/contract_reminder',
    name: 'contract_reminder',
    component: () => import('../views/ContractReminder/Index.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/contract_reminder/create',
    name: 'contract_reminder_create',
    component: () => import('../views/ContractReminder/Create.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/contract_reminder/:id',
    name: 'contract_reminder_read',
    component: () => import('../views/ContractReminder/Read.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/contract_reminder/:id/update',
    name: 'contract_reminder_update',
    component: () => import('../views/ContractReminder/Update.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/app',
    name: 'app',
    component: () => import('../views/App/Index.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/app/create',
    name: 'app_create',
    component: () => import('../views/App/Create.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/app/:id',
    name: 'app_read',
    component: () => import('../views/App/Read.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/app/:id/update',
    name: 'app_update',
    component: () => import('../views/App/Update.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/ll_broadcast',
    name: 'broadcast',
    component: () => import('../views/Broadcast/Index.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/ll_broadcast/create',
    name: 'broadcast_create',
    component: () => import('../views/Broadcast/Create.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/ll_broadcast/:id',
    name: 'broadcast_read',
    component: () => import('../views/Broadcast/Read.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/ll_broadcast/:id/update',
    name: 'broadcast_update',
    component: () => import('../views/Broadcast/Update.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/ll_broadcast/:id/multi-list',
    name: 'broadcast_multi-list',
    component: () => import('../views/Broadcast/MultiList.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/admin_log',
    name: 'admin_log_read',
    component: () => import('../views/AdminLog/AdminLog.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/app_version_management',
    name: 'app_version_management_read',
    component: () => import('../views/AppVersionManagement/Index.vue'),
    meta: {
      requiresAuth: true,
    },
  },

  //
  // {
  //   path: '/my_account',
  //   name: 'my_account',
  //   component: () => import('../views/MyAccount/Index.vue'),
  //   meta: {
  //     requiresAuth: true,
  //   },
  // },
  // {
  //   path: '/my_account/create',
  //   name: 'my_account_create',
  //   component: () => import('../views/MyAccount/Create.vue'),
  //   meta: {
  //     requiresAuth: true,
  //   },
  // },
  {
    path: '/account_setting',
    name: 'account_setting_read',
    component: () => import('../views/AccountSetting.vue'),
    // redirect: '/account_setting/:id',
    meta: {
      requiresAuth: true,
    },
  },
  // {
  //   path: '/my_account/:id/update',
  //   name: 'my_account_update',
  //   component: () => import('../views/MyAccount/Update.vue'),
  //   meta: {
  //     requiresAuth: true,
  //   },
  // },
  {
    path: '/act_idtf_assignment',
    name: 'act_idtf_assignment',
    component: () => import('../views/ActIdentification/Index.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/act_idtf_assignment/:id',
    name: 'act_idtf_assignment_read',
    component: () => import('../views/ActIdentification/Read.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/act_cnt_update',
    name: 'act_cnt_update',
    component: () => import('../views/ActIdentification/ActContentUpdate/Index.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/act_cnt_update/:id',
    name: 'act_cnt_update_read',
    component: () => import('../views/ActIdentification/ActContentUpdate/Read.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/act_cnt_update/:id/update',
    name: 'act_cnt_update_update',
    component: () => import('../views/ActIdentification/ActContentUpdate/Update.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/act_cnt_update/:id/review',
    name: 'act_cnt_update_review',
    component: () => import('../views/ActIdentification/ActContentUpdate/Review.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/act_cnt_review',
    name: 'act_cnt_review',
    component: () =>
      import('../views/ActIdentification/ActContentReview/Index.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/act_cnt_review/:id',
    name: 'act_cnt_review_read',
    component: () =>
      import('../views/ActIdentification/ActContentReview/Read.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/act_cnt_review/:id/review',
    name: 'act_cnt_review_review',
    component: () => import('../views/ActIdentification/ActContentReview/Review.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/idtf_update',
    name: 'idtf_update',
    component: () => import('../views/ActIdentification/IdtfUpdate/Index.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/idtf_update/:id',
    name: 'idtf_update_read',
    component: () => import('../views/ActIdentification/IdtfUpdate/Read.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/idtf_update/:id/review',
    name: 'idtf_update_review',
    component: () => import('../views/ActIdentification/IdtfUpdate/Review.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/idtf_review',
    name: 'idtf_review',
    component: () => import('../views/ActIdentification/IdtfReview/Index.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/idtf_review/:id',
    name: 'idtf_review_read',
    component: () => import('../views/ActIdentification/IdtfReview/Read.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/idtf_review/:id/review',
    name: 'idtf_review_review',
    component: () => import('../views/ActIdentification/IdtfReview/Review.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/idtf_review_overall',
    name: 'idtf_review_overall',
    component: () => import('../views/ActIdentification/IdtfReviewOverall/Index.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/idtf_review_overall/:id',
    name: 'idtf_review_overall',
    component: () => import('../views/ActIdentification/IdtfReviewOverall/Read.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/idtf_review_overall/:id/review',
    name: 'idtf_review_overall_review',
    component: () => import('../views/ActIdentification/IdtfReviewOverall/Review.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/role_type',
    name: 'role_type',
    component: () => import('../views/RoleType/Index.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/role_type/create',
    name: 'role_type_create',
    component: () => import('../views/RoleType/Create.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/role_type/:id',
    name: 'role_type_read',
    component: () => import('../views/RoleType/Read.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/role_type/:id/update',
    name: 'role_type_update',
    component: () => import('../views/RoleType/Update.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/subscription_api_demo',
    name: 'subscription_api_demo',
    component: () => import('../views/SubscriptionApiDemo/Index.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/subscription_api_demo/:moduleVal',
    name: 'subscription_api_demo_read',
    component: () => import('../views/SubscriptionApiDemo/Read.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/guideline/batch',
    name: 'guideline_batch',
    component: () => import('../views/Guideline/Batch.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/topic',
    name: 'topic',
    component: () => import('../views/Topic/Index.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/content_text',
    name: 'content_text',
    component: () => import('../views/ContentText/Index.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/content_text/create',
    name: 'content_text_create',
    component: () => import('../views/ContentText/Create.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/content_text/:id',
    name: 'content_text_read',
    component: () => import('../views/ContentText/Read.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/content_text/:id/update',
    name: 'content_text_update',
    component: () => import('../views/ContentText/Update.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/translation',
    name: 'translation',
    component: () => import('../views/Translation/Index.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/module_page',
    name: 'module_page',
    component: () => import('../views/ModulePage/Index.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/alliance',
    name: 'alliance',
    component: () => import('../views/Alliance/Index.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/alliance/create',
    name: 'alliance_create',
    component: () => import('../views/Alliance/Create.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/alliance/:id',
    name: 'alliance_read',
    component: () => import('../views/Alliance/Read.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/alliance/:id/update',
    name: 'alliance_update',
    component: () => import('../views/Alliance/Update.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/announcement',
    name: 'announcement',
    component: () => import('../views/Announcement/Index.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/announcement/create',
    name: 'announcement_create',
    component: () => import('../views/Announcement/Create.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/announcement/:id',
    name: 'announcement_read',
    component: () => import('../views/Announcement/Read.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/announcement/:id/update',
    name: 'announcement_update',
    component: () => import('../views/Announcement/Update.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/item_label_type',
    name: 'item_label_type',
    component: () => import('../views/Meeting/ItemLabelType/Index.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/meeting_template_field',
    name: 'meeting_template_field',
    component: () => import('../views/Meeting/MeetingTemplateField/Index.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/meeting_template_type',
    name: 'meeting_template_type',
    component: () => import('../views/Meeting/MeetingTemplateType/Index.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/date_format',
    name: 'date_format',
    component: () => import('../views/Meeting/DateFormat/Index.vue'),
    meta: {
      requiresAuth: true,
    },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.VUE_APP_BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

const accessToken = localStorage.getItem('access_token');
if (accessToken) {
  Axios.defaults.headers.common['Authorization'] = accessToken;
}

router.beforeEach(async (to, from, next) => {
  // CurrentUser Set
  let currentUser;
  if (accessToken && !store.state.user.tokenChecked) {
    try {
      const res = await Axios.get('auth/user');
      store.dispatch('user/setUserData', res.data.user);
      currentUser = res.data.user;
    } catch (err) {
      // alert('憑證過期，請重新登入');
      currentUser = null;
    }
  } else {
    currentUser = store.state.user.currentUser;
  }

  // Locale Set
  if (
    setting.data().SET_locale &&
    store.state.user.tokenChecked &&
    !store.state.locale.locales
  ) {
    try {
      const res = await Axios.get('/locale');
      store.dispatch('locale/setLocales', res.data.data);
    } catch (err) {
      alert('取得語言列表錯誤');
    }
  }

  // Auth Check
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  if (requiresAuth && !currentUser) {
    const query = to.path && to.path != '/' ? { redirect: to.path } : {};
    next({ path: '/signin', query: query });
    return;
  }

  // Signin Check
  if (to.name == 'signin') {
    if (!currentUser) {
      next();
      return;
    } else {
      next('/');
      return;
    }
  }

  // Signout Check
  if (to.name == 'signout') {
    if (!currentUser) {
      next('/signin');
      return;
    } else {
      next();
      return;
    }
  }

  // Role Check
  const requiresRoles = to.meta.requiresRoles;
  if (
    requiresRoles &&
    requiresRoles.length &&
    currentUser.roles &&
    currentUser.roles.length
  ) {
    const hasRole = requiresRoles.some(
      (role) => currentUser.indexOf(role) >= 0,
    );
    if (!hasRole) {
      next('404');
      return;
    }
  }

  next();
  return;
});

export default router;
